function DirectContact(config, renderer) {
  const self = this;

  self.init = function () {
    return {
      user: {
        phone: session.user.phone,
        email: ""
      }
    }
  }

  function bindSubmitHandler() {
    document.querySelector("#js-send-contact-information").addEventListener('click', submitHandler)
  }

  function submitHandler() {
    const phone = document.querySelector('[name=phone]').value
    const email = document.querySelector('[name=email]').value

    Fetch.post('/direct-contact/send', {phone: phone, email: email})
      .then(
        function () {
          window.location.href = '/'
        },
        function (failure) {
          document.getElementById('page').innerHTML = renderer.template('directcontact')(failure);
          bindSubmitHandler()
        });
  }

  self.done = function () {
    bindSubmitHandler()
  }
}